import { render, staticRenderFns } from "./TheScreenProjectFunding.vue?vue&type=template&id=478d74c1&"
import script from "./TheScreenProjectFunding.vue?vue&type=script&lang=js&"
export * from "./TheScreenProjectFunding.vue?vue&type=script&lang=js&"
import style0 from "./TheScreenProjectFunding.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports